var _rect, _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F3E7D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.751 31.9397H23.498C23.084 31.9397 22.748 31.6037 22.748 31.1897C22.748 30.7757 23.084 30.4397 23.498 30.4397H30.751C31.165 30.4397 31.501 30.7757 31.501 31.1897C31.501 31.6037 31.165 31.9397 30.751 31.9397",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1496_6616",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 13,
    width: 18,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.0002H29.1806V31.9397H12V13.0002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1496_6616)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1103 15.0168L13.6953 26.7918C13.5243 27.0058 13.4613 27.2818 13.5243 27.5468L14.2053 30.4318L17.2443 30.3938C17.5333 30.3908 17.8003 30.2618 17.9773 30.0418C21.1943 26.0168 27.3273 18.3428 27.5013 18.1178C27.6653 17.8518 27.7293 17.4758 27.6433 17.1138C27.5553 16.7428 27.3243 16.4278 26.9913 16.2268C26.9203 16.1778 25.2353 14.8698 25.1833 14.8288C24.5493 14.3208 23.6243 14.4088 23.1103 15.0168V15.0168ZM13.6133 31.9398C13.2663 31.9398 12.9643 31.7018 12.8833 31.3628L12.0643 27.8918C11.8953 27.1728 12.0633 26.4308 12.5243 25.8548L21.9443 14.0728C21.9483 14.0688 21.9513 14.0638 21.9553 14.0598C22.9883 12.8248 24.8563 12.6428 26.1163 13.6538C26.1663 13.6928 27.8393 14.9928 27.8393 14.9928C28.4473 15.3548 28.9223 16.0018 29.1023 16.7678C29.2813 17.5258 29.1513 18.3078 28.7343 18.9688C28.7033 19.0178 28.6763 19.0598 19.1483 30.9798C18.6893 31.5518 18.0013 31.8848 17.2623 31.8938L13.6233 31.9398H13.6133Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2234 21.6848C26.0634 21.6848 25.9034 21.6338 25.7664 21.5298L20.3144 17.3418C19.9864 17.0898 19.9244 16.6198 20.1764 16.2898C20.4294 15.9618 20.8994 15.9008 21.2284 16.1528L26.6814 20.3398C27.0094 20.5918 27.0714 21.0628 26.8184 21.3918C26.6714 21.5838 26.4484 21.6848 26.2234 21.6848",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.4634d1a3a02ece08606cc05df5a6763b.svg";
export { ForwardRef as ReactComponent };